import { copilotInstructions as s, copilotTools as u, copilotContext as i } from "./global-state.js";
import { prepareInstructionsForTransport as e, prepareToolsForTransport as a, prepareContextForTransport as r } from "./session.js";
function d(n, l, t = {}) {
  t = {
    instructions: t.instructions ?? [],
    context: t.context ?? [],
    includeGlobalContext: !0,
    includeGlobalTools: !0,
    includeGlobalInstructions: !0,
    ...t
  };
  const o = window.__hydra_copilot__?.generate;
  if (o == null)
    throw new Error("Copilot generate not configured. Please set the Copilot configuration first.");
  return o({
    message: n,
    schema: l,
    instructions: [
      ...t.includeGlobalInstructions ? e(s.get()) : [],
      ...e(t.instructions)
    ],
    tools: t.includeGlobalTools ? a(u.get()) : [],
    context: [
      ...t.includeGlobalContext ? r(i.get()) : [],
      ...r(t.context)
    ],
    ...t.includeUserContext === !0 && { include_user_context: !0 }
  });
}
export {
  d as generate
};
